<template>
  <div
    class="text-center laptop:my-6 my-6 mobile:my-3 grid laptop:grid-cols-3 desktop:grid-cols-3 largeDesktop:grid-cols-3 mobile:grid-cols-1 items-center mobile:gap-3 laptop:gap-5">
    <div></div>
    <div class="text-center">
      <h2 class="mb-0 font-bold font-roboto mobile:text-xl laptop:text-2xl largeDesktop:text-4xl text-gray-900">
        {{ getHeading() }}
      </h2>
      <p class="mb-0 font-normal font-roboto mobile:text-base desktop:text-lg text-[#666666]">
        {{ getText() }}
      </p>
    </div>
    <div class="laptop:text-right mobile:text-center" v-if="isShowProtectionPlanNumber">
      <p class="mb-0 font-normal font-roboto mobile:text-base desktop:text-lg text-[#666666]">Protection Plan Questions
        Call</p>
      <a href="tel:+18668433371"
        class="mb-0 font-bold font-roboto mobile:text-lg laptop:text-xl largeDesktop:text-2xl no-underline text-[#A084E8]">
        (866)-843-3371
      </a>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    heading: {
      type: String,
      default: 'Welcome',
    },
    text: {
      type: String,
      default: 'Let’s make today productive and achieve some great results',
    },
  },

  data() {
    return {
      user: JSON.parse(localStorage.getItem('user')) ?? null
    };
  },

  computed: {
    isShowProtectionPlanNumber() {
      if (this.$route.name == 'salesHistory') {
        return false
      } else if (
        this.$route.name == 'hvac-plan' ||
        this.$route.name == 'partner' ||
        this.$route.name == 'protections-plans' ||
        this.$route.name == 'plan' ||
        this.$route.name == 'bundleList' ||
        this.$route.name == 'plumbing-plan' ||
        this.$route.name == 'electric-plan'
      ) {
        return true
      } else if (
        this.$route.name == 'globalSearch'
      ) {
        return true
      } else {
        return false
      }
    },
  },

  methods: {

    getText() {
      if (this.$route.name == 'salesHistory') {
        return 'Protection Plans - Sales History'
      } else if (this.$route.name == 'commisionAmount') {
        return 'Protection Plans - Commissions'
      } else if (
        this.$route.name == 'hvac-plan' ||
        this.$route.name == 'partner' ||
        this.$route.name == 'protections-plans' ||
        this.$route.name == 'plan' ||
        this.$route.name == 'bundleList' ||
        this.$route.name == 'plumbing-plan' ||
        this.$route.name == 'electric-plan'
      ) {
        return 'Optional NRG Protects Inc Protection Plans'
      } else if (
        this.$route.name == 'globalSearch'
      ) {
        return 'Results matching your search criteria are listed below.'
      } else {
        return 'Let’s make today productive and achieve some great results'
      }
    },

    getHeading() {
      if (this.$route.name == 'salesHistory' || this.$route.name == 'commisionAmount') {
        return 'Protection Plans'
      } else if (
        this.$route.name == 'hvac-plan' ||
        this.$route.name == 'partner' ||
        this.$route.name == 'protections-plans' ||
        this.$route.name == 'plan' ||
        this.$route.name == 'bundleList' ||
        this.$route.name == 'plumbing-plan' ||
        this.$route.name == 'electric-plan'
      ) {
        return 'Protection Plans'
      } else if (
        this.$route.name == 'globalSearch'
      ) {
        return 'Search Results '
      } else if (
        this.$route.name == 'partnerCheckout'
      ) {
        return 'Checkout '
      } else {
        return 'Welcome ' + (this.user ? this.user.user.full_name : '')
      }
    }

  },
}
</script>